import { defineAsyncComponent } from 'vue'

import type {
  ComponentPageListing,
  ComponentPageSearch,
  ComponentSPListItem,
  ComposablePageListing,
  ComposableSPListItem,
} from '@/types/async'

export const useAsyncComponents = () => {
  const getComponentPage = (
    component: string,
  ): ComponentPageListing | ComponentPageSearch =>
    defineAsyncComponent(
      () => import(`@/components/async/Page/${component}.vue`),
    )

  const getComposablePageListing = async (
    composable: string,
  ): Promise<ComposablePageListing> => {
    const { useVarPool: composablePageListing } = (await import(
      `./async/PageListing/${composable}.ts`
    )) as { useVarPool: ComposablePageListing }

    return composablePageListing
  }

  const getComponentSPListItem = (component: string): ComponentSPListItem =>
    defineAsyncComponent(
      () => import(`@/components/async/SPListItem/${component}.vue`),
    )

  const getComposableSPListItem = async (
    composable: string,
  ): Promise<ComposableSPListItem> => {
    const { useVarPool: composableSPListItem } = (await import(
      `./async/SPListItem/${composable}.ts`
    )) as { useVarPool: ComposableSPListItem }

    return composableSPListItem
  }

  return {
    getComponentPage,
    getComponentSPListItem,
    getComposablePageListing,
    getComposableSPListItem,
  }
}
